import { css } from '@emotion/css'
import { theme as deprecatedTheme } from '../../styled'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { ClassNameConfig } from '.'

export const convertCamelCaseToKabobCase = (key) =>
  key
    .split('')
    .map(
      (c, i) => (i > 0 && c === c.toUpperCase() ? '-' : '') + c.toLowerCase()
    )
    .join('')

export function convertStyleConfigToClassname(config: ClassNameConfig) {
  const str = Object.keys(config)
    .map((key) => {
      let val = config[key]
      if (key === 'fontFamily') {
        val = deprecatedTheme.fontFamilies[val]
      } else if (key === 'fontWeight' && isNaN(val)) {
        val = deprecatedTheme.fontWeights[config.fontFamily][val]
      } else if (key === 'color') {
        val = theme.color[val]
      }
      return `${convertCamelCaseToKabobCase(key)}: ${val};`
    })
    .join('\n')
  return css`
    ${str};
  `
}
